<template>
    <section id="page-bekenden" class="page page--type2">
        <div class="page__content">
            <h1 class="page-bekenden__description">Deze hybride docenten ken je misschien al</h1>

            <!-- Rutte -->
            <div class="page-bekenden__persona page-bekenden__rutte">
                <flipper class="page-bekenden__flipper">
                    <div slot="front">
                        <div class="portret portret--white"></div>
                    </div>
                    <div slot="back">
                        <div class="portret portret--white portret--back"></div>
                        <p>Mark Rutte</p>
                    </div>
                </flipper>
                <div class="container page-bekenden__jobs">
                    <div class="row">
                        <div class="col-5 page-bekenden__job page-bekenden__job--left">
                            Docent maatschappijleer
                        </div>
                        <div class="col-2">
                            <img class="page-bekenden__plus" src="../../assets/icons/plus-white.svg">
                        </div>
                        <div class="col-5 page-bekenden__job page-bekenden__job--right">
                            Minister-president
                        </div>
                    </div>
                </div>
            </div>
            <page-next-button class="page-bekenden__next-section" v-on:click="nextSectionHandler"></page-next-button>
            <!-- Walter White -->
            <div class="page-bekenden__persona page-bekenden__white">
                <flipper class="page-bekenden__flipper">
                    <div slot="front">
                        <div class="portret portret--white"></div>
                    </div>
                    <div slot="back">
                        <div class="portret portret--white portret--back"></div>
                        <p>Walter White</p>
                    </div>
                </flipper>
                <div class="container page-bekenden__jobs">
                    <div class="row">
                        <div class="col-5 page-bekenden__job page-bekenden__job--left">
                            Docent scheikunde
                        </div>
                        <div class="col-2">
                            <img class="page-bekenden__plus" src="../../assets/icons/plus-white.svg">
                        </div>
                        <div class="col-5 page-bekenden__job page-bekenden__job--right">
                            Heisenberg
                        </div>
                    </div>
                </div>
            </div>

            <div id="page-bekenden__next-btn">
                <page-next-button v-on:click="nextHandler"></page-next-button>
            </div>

        </div>
    </section>
</template>
<style lang="stylus">


    .page-bekenden__description
        margin-bottom 100px

    .page-bekenden__persona
        margin-bottom 100px

    .page-bekenden__flipper.flipper
        width 200px
        height 230px
        transform scale(0)
        margin-bottom 30px

    #page-bekenden .portret
        width 200px
        height 200px

    .page-bekenden__rutte
        .portret--back
            background-image url('../../assets/images/rutte-portret.jpg')

    .page-bekenden__white
        .portret--back
            background-image url('../../assets/images/white-portret.jpg')

    .page-bekenden__next-section
        opacity 0

    .page-bekenden__jobs
        height 70px
        .row
            display flex
            align-items center

    .page-bekenden__plus
        height 70px
        transform scale(0)

    .page-bekenden__job
        transform scale(0)
        &.page-bekenden__job--left span
            align-self flex-end

    #page-bekenden__next-btn
        opacity 0
</style>
<script>
    const ScrollMagic = require('ScrollMagic');
    const TimelineMax = require('TimelineMax');

    import flipper from '../flipper/flipper.vue';

    import page from './page';

    export default {
        mixins: [page],
        data() {
            return {
                flip: {
                    rutte: {
                        image: false,
                        sum: false
                    }
                }
            }
        },
        methods: {
            initAnimation() {
                const persons = ['rutte', 'white'];

                let timeline = new TimelineMax();
                this.animatePerson('rutte', timeline);
                timeline.to(".page-bekenden__next-section", .8, {opacity: 1, delay: 2.5});

                new ScrollMagic.Scene( {
                        triggerElement: '#page-bekenden',
                        duration: 300,
                        offset: -300
                    })
                    .setTween(timeline)
                    .addTo(this.scroller);


                timeline = new TimelineMax();
                this.animatePerson('white', timeline);
                timeline.to("#page-bekenden__next-btn", .8, {opacity: 1, delay: .5});

                new ScrollMagic.Scene( {
                        triggerElement: '.page-bekenden__white',
                        duration: 200,
                        offset: -200
                    })
                    .setPin('.page-bekenden__white')
                    .setTween(timeline)
                    .addTo(this.scroller);
            },
            animatePerson(person, timeline) {
                timeline
                    .to(`.page-bekenden__${person} .page-bekenden__flipper`, .6, {scale: 1})
                    .set(`.page-bekenden__${person} .page-bekenden__flipper`,
                        { className: "+=flipper--flipped"})
                    .to(`.page-bekenden__${person} .page-bekenden__job--left`, .6, {scale: 1, delay: 1})
                    .to(`.page-bekenden__${person} .page-bekenden__plus`, .6, {scale: 1})
                    .to(`.page-bekenden__${person} .page-bekenden__job--right`, .6, {scale: 1})
            },
            nextSectionHandler() {
                TweenLite.to(window, 1, {scrollTo: '.page-bekenden__white'});
            }
        },
        components: {
            flipper
        }
    }

</script>



// WEBPACK FOOTER //
// page-bekenden.vue?d5d0c80c